var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMultiUser = function SvgMultiUser(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#multi-user_svg__a)",
    rx: 16
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#multi-user_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "multi-user_svg__c",
    width: 24,
    height: 24,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M4 4h24v24H4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#multi-user_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.596 15.642q.638-.694.944-1.594t.306-1.856-.306-1.855a4.4 4.4 0 0 0-.944-1.595q1.317.152 2.188 1.138.87.986.87 2.312 0 1.328-.87 2.313a3.33 3.33 0 0 1-2.188 1.137m4.863 7.666q.189-.345.288-.733.1-.389.1-.786v-.827q0-.818-.334-1.556a3.6 3.6 0 0 0-.944-1.267q1.15.382 2.117 1.032t.968 1.79v.828q0 .632-.444 1.076a1.47 1.47 0 0 1-1.075.443zm2.195-8.558h-1.25a.73.73 0 0 1-.535-.216.73.73 0 0 1-.215-.534q0-.319.215-.534a.73.73 0 0 1 .535-.216h1.25V12q0-.318.215-.534a.73.73 0 0 1 .535-.216q.319 0 .534.216a.73.73 0 0 1 .216.534v1.25h1.25q.318 0 .534.216a.73.73 0 0 1 .216.534q0 .32-.216.535a.73.73 0 0 1-.534.215h-1.25V16q0 .319-.216.534a.73.73 0 0 1-.535.216.73.73 0 0 1-.534-.216.73.73 0 0 1-.215-.534zm-11.308.942q-1.443 0-2.472-1.028t-1.028-2.472q0-1.443 1.028-2.471t2.472-1.029 2.472 1.029 1.028 2.471-1.028 2.472q-1.028 1.029-2.472 1.028m-7.5 6.097v-.704q0-.735.4-1.36a2.66 2.66 0 0 1 1.065-.963 14.5 14.5 0 0 1 2.992-1.09 12.94 12.94 0 0 1 6.086 0q1.509.363 2.992 1.09.667.336 1.066.962.4.627.4 1.36v.705q0 .632-.444 1.076a1.47 1.47 0 0 1-1.076.443H6.365q-.632 0-1.076-.443a1.47 1.47 0 0 1-.443-1.076m7.5-7.597q.825 0 1.413-.587.587-.588.587-1.413 0-.824-.587-1.412a1.93 1.93 0 0 0-1.413-.588q-.825 0-1.412.588a1.93 1.93 0 0 0-.588 1.412q0 .825.588 1.413.587.587 1.412.587m-6 7.616h12v-.723a1 1 0 0 0-.176-.563 1.33 1.33 0 0 0-.478-.422 13 13 0 0 0-2.635-.964 11.4 11.4 0 0 0-5.422 0Q8.292 19.464 7 20.1q-.301.165-.478.422a1 1 0 0 0-.176.563z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "multi-user_svg__a",
    x1: 3,
    x2: 36,
    y1: 30,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4277FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "multi-user_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h24v24H4z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMultiUser);
export default ForwardRef;